"use client";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import { APP_CONSTANTS } from "./constants";
import Hero from "./hero";
import IntroComponent from "./intro";
import WhyOneMind from "./whyOneMind";
import GetStarted from "./accessAdmin";
import Connection from "./connection";
import FeaturesComp from "./features";
import BenefitsComp from "./resilience";
import SupportComponent from "./support";
import PageNotFound from "@/views/pageNotFound";

const AppDetailsPage = ({ slug }) => {
  const content = APP_CONSTANTS[slug];
  if (!content) {
    return <PageNotFound />;
  }
  const {
    HERO,
    INTRO,
    WHY_ONEMIND,
    GET_STARTED,
    CONNECTION,
    FEATURES,
    BENEFITS,
    SUPPORT,
  } = content;
  return (
    <Box>
      <Hero {...HERO} />
      <PageLayout>
        <IntroComponent {...INTRO} />
      </PageLayout>
      <WhyOneMind {...WHY_ONEMIND} />
      <PageLayout showContactForm>
        <GetStarted {...GET_STARTED} />
        {CONNECTION && <Connection {...CONNECTION} />}
        <FeaturesComp {...FEATURES} />
        <BenefitsComp {...BENEFITS} />
        <SupportComponent {...SUPPORT} />
      </PageLayout>
    </Box>
  );
};

export default AppDetailsPage;
